var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"balloon"}},[(_vm.result)?_c('div',{staticClass:"hand-result elevation-2 ml-n5 ml-lg-0",style:({ width: _vm.width, left: _vm.left })},[_vm._v("\n    "+_vm._s(_vm.result.toUpperCase())+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }